// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/chip-set.js
import BaseComponent from "./base_component"
import Chip from "./chip"

export default class ChipSet extends BaseComponent {
  static componentName = "chip-set"
  static defaults = {
    filter: false,
    selectable: false,
    removable: false,
    selectionMode: "multiple",
    unique: false,
    maxChips: 0,
  }

  constructor(element, config = {}) {
    super(element, config)
    this.chips = [...element.querySelectorAll(":scope > .chip")].map((chip) => this.mount(chip))
    this.listen(element, "selected.coreui.chip", (event) => this.selectionChanged(event))
    this.listen(element, "deselected.coreui.chip", () => this.emitSelection())
    this.listen(element, "removed.coreui.chip", (event) => {
      const index = this.chips.findIndex((chip) => chip.element === event.target)
      this.chips.splice(index, 1)
      this.changed()
      this.emitSelection()
      ;(this.chips[index]?.element || this.chips.at(-1)?.element || this.input)?.focus()
    })
    this.listen(element, "keydown", (event) => {
      if (!event.target.matches(".chip") || !["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return
      event.preventDefault()
      const chips = this.chips.filter((chip) => !chip.disabled)
      const current = chips.findIndex((chip) => chip.element === event.target)
      const next =
        event.key === "Home"
          ? 0
          : event.key === "End"
            ? chips.length - 1
            : (current + (event.key === "ArrowRight" ? 1 : -1) + chips.length) % chips.length
      chips[next]?.element.focus()
    })
  }

  mount(element) {
    return Chip.getOrCreateInstance(element, {
      ...this.config,
      disabled: this.config.disabled || this.config.readonly || element.classList.contains("disabled"),
    })
  }

  selectionChanged(event) {
    if (this.config.selectionMode === "single")
      this.chips.forEach((chip) => {
        if (chip.element !== event.target) {
          chip.selected = false
          chip.update()
        }
      })
    this.emitSelection()
  }

  emitSelection() {
    this.emit("select", { selected: this.chips.filter((chip) => chip.selected).map((chip) => chip.value) })
  }
  getValues() {
    return this.chips.map((chip) => chip.value)
  }
  changed() {
    this.emit("change", { values: this.getValues() })
  }

  add(value) {
    value = value.trim()
    if (!value || this.config.disabled || this.config.readonly) return false
    if (this.config.unique && this.getValues().includes(value)) return false
    if (this.config.maxChips && this.chips.length >= this.config.maxChips) return false
    const element = document.createElement("span")
    element.className = `chip ${this.config.chipClassName || ""}`.trim()
    element.textContent = value
    if (this.input) this.input.before(element)
    else this.element.append(element)
    this.chips.push(this.mount(element))
    this.changed()
    return true
  }

  dispose() {
    if (this.signal.aborted) return
    this.chips.forEach((chip) => chip.dispose())
    this.element.innerHTML = this.originalHTML
    this.element.className = this.originalClassName
    super.dispose()
  }
  snapshotState() {
    return {
      chips: this.chips.map((chip) => ({
        value: chip.value,
        selected: chip.selected,
        disabled: chip.disabled,
        className: chip.originalClassName,
      })),
      text: this.input?.value,
    }
  }
  restoreState(state) {
    if (!state.chips) return
    this.chips.forEach((chip) => {
      chip.dispose()
      chip.element.remove()
    })
    this.chips = state.chips.map((item) => {
      const element = document.createElement("span")
      element.className = item.className
      element.textContent = item.value
      element.classList.toggle("active", item.selected)
      element.classList.toggle("disabled", item.disabled)
      if (this.input) this.input.before(element)
      else this.element.append(element)
      return this.mount(element)
    })
    if (this.input) this.input.value = state.text || ""
    this.syncValue?.()
  }
}
